export const SET_LOADING_SHOW = 'loading/show'
export const SET_LOADING_HIDE = 'loading/hide'
